import React from "react";
/* eslint-disable */
import {
  Box, Card, Grid, CardContent, Divider, CardHeader,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const productData = this.props.productList;
    const data = this.props.searchData;

    return (
      <div>
        <div>&nbsp;</div>
        <h3><center><u>Farmer Crop Wise Transaction</u></center></h3>
        <div>&nbsp;</div>
        {/* <h4><left>Group - {data.groupID}</left></h4>
        <h4><left>Fresh Collection Center - {data.operationEntityID}</left></h4>
        <h4><left>Product Category - {data.cropCategoryID}</left></h4>
        <h4><left>Product - {data.cropID}</left></h4>
        <h4><left>{data.fromDate} - {data.toDate}</left></h4> */}

        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell align={'left'}>Fresh Collection Center</TableCell>
                  <TableCell align={'left'}>Product Name</TableCell>
                  <TableCell align={'left'}>Date</TableCell>
                  <TableCell align={'right'}>Allocated Quantity</TableCell>
                  <TableCell align={'right'}>Supplied Quantity</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productData.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.factoryName}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.productName}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {new Date(data.orderDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
                    </TableCell>
                     <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.allocatedQuantity.toFixed(2)}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.quantity.toFixed(2)}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold'}}>
                  <TableCell colSpan={3} align="right" style={{ fontWeight: 'bold', borderBottom: "none" }}>
                    <strong>Total:</strong>
                  </TableCell>
                  <TableCell align={'right'} style={{ fontWeight: 'bold', borderBottom: "none" }}>
                    {productData.reduce((sum, row) => sum + row.allocatedQuantity, 0).toFixed(2)}
                  </TableCell>
                  <TableCell align={'right'} style={{ fontWeight: 'bold', borderBottom: "none" }}>
                    {productData.reduce((sum, row) => sum + row.quantity, 0).toFixed(2)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>

    );
  }
}
